


import { useState } from 'react';
import { useAppStore } from '@/modules/core/appstore/services/store';
import { ListSkeleton } from '@/components/base/Skeleton';

export default function BuyModal() {
  const { showBuyModal, setShowBuyModal, selectedApp, purchaseApp } = useAppStore();
  const [isProcessing, setIsProcessing] = useState(false);

  if (!showBuyModal || !selectedApp) return null;

  const handlePurchase = async () => {
    setIsProcessing(true);
    
    // Simulate payment processing
    setTimeout(() => {
      purchaseApp(selectedApp.id);
      setIsProcessing(false);
    }, 2000);
  };

  const handleClose = () => {
    if (!isProcessing) {
      setShowBuyModal(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-2xl max-w-md w-full">
        <div className="p-6 border-b border-gray-200">
          <div className="flex items-center justify-between">
            <h2 className="text-xl font-bold text-gray-900">Purchase App</h2>
            {!isProcessing && (
              <button
                onClick={handleClose}
                className="text-gray-400 hover:text-gray-600 transition-colors"
              >
                <i className="ri-close-line text-2xl"></i>
              </button>
            )}
          </div>
        </div>

        <div className="p-6">
          <div className="flex items-center gap-4 mb-6">
            <div className="w-16 h-16 rounded-lg overflow-hidden">
              <img
                src={selectedApp.coverImage}
                alt={selectedApp.name}
                className="w-full h-full object-cover"
              />
            </div>
            <div>
              <h3 className="font-semibold text-lg text-gray-900">{selectedApp.name}</h3>
              <p className="text-gray-600 text-sm">{selectedApp.category}</p>
            </div>
          </div>

          <div className="bg-gray-50 rounded-lg p-4 mb-6">
            <div className="flex justify-between items-center">
              <span className="text-gray-700">License:</span>
              <span className="text-gray-900">Lifetime</span>
            </div>
          </div>

          <div className="mb-6">
            <h4 className="font-medium text-gray-900 mb-2">What's included:</h4>
            <ul className="space-y-2 text-sm text-gray-600">
              <li className="flex items-center">
                <i className="ri-check-line text-green-500 mr-2"></i>
                Full access to all features
              </li>
              <li className="flex items-center">
                <i className="ri-check-line text-green-500 mr-2"></i>
                Regular updates and bug fixes
              </li>
              <li className="flex items-center">
                <i className="ri-check-line text-green-500 mr-2"></i>
                Priority customer support
              </li>
              <li className="flex items-center">
                <i className="ri-check-line text-green-500 mr-2"></i>
                30-day money-back guarantee
              </li>
            </ul>
          </div>

          {isProcessing ? (
            <ListSkeleton />
          ) : (
            <div className="flex gap-3">
              <button
                onClick={handleClose}
                className="flex-1 px-6 py-3 border border-gray-200 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium whitespace-nowrap"
              >
                Cancel
              </button>
              <button
                onClick={handlePurchase}
                className="flex-1 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium whitespace-nowrap flex items-center justify-center"
              >
                <i className="ri-shopping-cart-line mr-2"></i>
                Buy Now
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
